"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Step = _interopRequireDefault(require("./Step"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};

          if (desc.get || desc.set) {
            Object.defineProperty(newObj, key, desc);
          } else {
            newObj[key] = obj[key];
          }
        }
      }
    }

    newObj["default"] = obj;
    return newObj;
  }
}

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);

    if (typeof Object.getOwnPropertySymbols === 'function') {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }

    ownKeys.forEach(function (key) {
      _defineProperty(target, key, source[key]);
    });
  }

  return target;
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var StepGroup =
/*#__PURE__*/
function (_Component) {
  _inherits(StepGroup, _Component);

  function StepGroup() {
    _classCallCheck(this, StepGroup);

    return _possibleConstructorReturn(this, _getPrototypeOf(StepGroup).apply(this, arguments));
  }

  _createClass(StepGroup, [{
    key: "render",
    value: function render() {
      var _this = this;

      var _this$props = this.props,
          active = _this$props.active,
          partial = _this$props.partial,
          completed = _this$props.completed,
          connectorColor = _this$props.connectorColor,
          activeSubStep = _this$props.activeSubStep;
      return _react["default"].createElement(_react.Fragment, null, _react["default"].createElement(_Step["default"], _extends({}, this.props, {
        index: this.props.index.toString()
      }), this.props.contents), _react["default"].createElement("div", {
        style: {
          borderLeft: "2px dotted ".concat(connectorColor),
          margin: '4px 0 4px 9px',
          paddingLeft: '9px',
          flexDirection: 'column'
        }
      }, _react.Children.map(this.props.children, function (step, index) {
        var controlProps = {
          activeColor: _this.props.activeColor,
          small: true,
          vertical: true,
          index: "".concat(_this.props.index, ".").concat(index)
        };

        if (active && activeSubStep === index) {
          controlProps.active = true;
          controlProps.partial = partial;
        } else if (completed || active && activeSubStep > index) {
          controlProps.completed = true;
        }

        return _react["default"].cloneElement(step, _objectSpread({}, controlProps, step.props));
      })));
    }
  }]);

  return StepGroup;
}(_react.Component);

exports["default"] = StepGroup;

_defineProperty(StepGroup, "propTypes", {
  active: _propTypes["default"].bool,
  partial: _propTypes["default"].bool,
  completed: _propTypes["default"].bool,
  activeSubStep: _propTypes["default"].number,
  contents: _propTypes["default"].node,
  connectorColor: _propTypes["default"].string,
  index: _propTypes["default"].number,
  activeColor: _propTypes["default"].string,
  children: _propTypes["default"].node
});

_defineProperty(StepGroup, "defaultProps", {
  index: 0
});